import React, { useState, useRef, useCallback, useEffect } from 'react';
import { getStatisticsFromOrigin } from "./helpers/requestHandler";

import { DropDownBox } from 'devextreme-react/drop-down-box';
import { List } from "devextreme-react/list";

import { updateUsersInstance, updateUsersRange } from "./graphs/lineChartHistoricUsers";
import { updateNoticesInstance, updateNoticesRange } from "./graphs/lineChartHistoricNotices";
import { updateInstanceHome } from "./pages/home";
import { updateInstanceAcademy } from "./pages/academy";
import { updateInstanceReachback } from './pages/reachback';
import { updateInstanceShopify } from './pages/shopify';


/**
 * Calculates the unique instance names from a large data object.
 * @returns {array} Unique array with one of each instance name as a string.
 */

async function getInstanceNames() {
    let instances = await getStatisticsFromOrigin(global.config.backend.baseURI + "/api/Statistic/GetActiveUsersByInstanceRange", 30)

    if(instances) {
        const uniqueInstancesSet = new Set();
        instances.forEach(obj => {
            uniqueInstancesSet.add(obj.instance);
        });
    
        return Array.from(uniqueInstancesSet);
    }
}

/**
 * Configures and then returns a dropdown component based on prop data.
 * @param {object} - Prop input containing an ID
 * @returns {component} Dropdown component consisting of prop data.
 */

export default function Dropdown(data) {
    const [selectedData, setSelectedData] = useState(data.id === "instance" ? global.config.dashboard.selectedInstance : global.config.dashboard.range);
    const [dataSource, setDataSource] = useState([]);
    const dropDownBoxRef = useRef(null);

    useEffect(() => {
        switch(data.id) {
            case "instance":
                getInstanceNames().then(resp => {
                    setDataSource(resp);
                 })
                break;
            case "range":
                setDataSource([30, 60, 90, 120])
                break;
            default:
                break;
        }
        // eslint-disable-next-line
      }, []);

    const changeDropDownBoxValue = useCallback((arg) => {
        setSelectedData(arg.addedItems[0]);
        dropDownBoxRef.current.instance.close();
    }, []);

    const onValueChanged = useCallback((e) => {
        // Each case within this function is used to trigger specific functions. 
        // If we require an update on the "users" page, running the updateUsersInstance() function
        // Will allow the page to reload with the new data.
        switch(data.id) {
            case "instance":
                global.config.dashboard.selectedInstance = e.value;
                if(window.location.pathname === "/users") { // Fix for black screens, prevents a non constructed function from running.
                    updateUsersInstance();
                } else if(window.location.pathname === "/notices") {
                    updateNoticesInstance();
                }
                break;
            case "range":
                global.config.dashboard.range = e.value;
                if(window.location.pathname === "/" || window.location.pathname === "/home") {
                    updateInstanceHome();
                }
                if(window.location.pathname === "/academy") {
                    updateInstanceAcademy();
                }
                if(window.location.pathname === "/reachback") {
                    updateInstanceReachback();
                }
                if(window.location.pathname === "/shopify") {
                    updateInstanceShopify();
                }
                if (window.location.pathname === "/users"){
                    setSelectedData(e.value);
                    data.onDropDownChange(e.value);
                    updateUsersRange();
                }
                if (window.location.pathname === "/notices"){
                    setSelectedData(e.value);
                    data.onDropDownChange(e.value);
                    updateNoticesRange();
                }
                break;
            default:
                break;
        }
        // eslint-disable-next-line
    }, []);

    return (
        <DropDownBox
            className="mb-3"
            dataSource={dataSource}
            value={selectedData}
            ref={dropDownBoxRef}
            onValueChanged={onValueChanged}
            label={data.id === "instance" ? "Instance" : "Range (Days)"}
        >
        <List
            dataSource={dataSource}
            selectionMode="single"
            selectedItem={selectedData}
            onSelectionChanged={changeDropDownBoxValue}
        />
        </DropDownBox>
    );
};
